module.exports = __webpack_public_path__ + "img/comdis.8f62aa18.jpg";